import { Leasing, Selling } from '../../../shared/model/constants/customerChannels';
import { ForLease, ForSale, Invest, Leased, Sold } from '../../../shared/model/constants/channels';

const imageMap = new Map([
  [ForSale.id, 'buy'],
  [ForLease.id, 'rent'],
  [Invest.id, 'invest'],
  [Sold.id, 'sold'],
  [Leased.id, 'leased'],
  [Selling.id, 'customer-search'],
  [Leasing.id, 'customer-search'],
]);

export const getBackgroundImageFromId = (channelId: string): string =>
  imageMap.get(channelId) || 'buy';
